import React from "react";
import { AlertTriangle, Lightbulb, Sparkles, ShieldAlert, Check, X } from "lucide-react";

export const ComicPanel = ({ children, className = "", tilt = 0, color = "#fff" }) => (
  <div
    className={`brutal p-6 sm:p-8 relative ${className}`}
    style={{ transform: `rotate(${tilt}deg)`, background: color }}
  >
    {children}
  </div>
);

export const SpeechBubble = ({ children, from = "carlos", className = "" }) => {
  // 'from' just tags where the tail sits (left/right)
  const isLeft = from === "carlos" || from === "left";
  return (
    <div className={`relative brutal p-4 sm:p-5 max-w-xl bubble-tail ${className}`}
      style={{ background: "#fff" }}>
      <div className="text-base sm:text-lg font-semibold leading-snug">{children}</div>
      {/* small pointer label */}
      <div className={`absolute -top-3 ${isLeft ? "left-4" : "right-4"} bg-canales-yellow border-2 border-black rounded-full px-2 text-xs font-display font-bold`}>
        {from.toUpperCase()}
      </div>
    </div>
  );
};

export const FactBox = ({ variant = "did_you_know", title, children }) => {
  const map = {
    did_you_know: { bg: "bg-[#005BBB]/10", border: "border-[#005BBB]", icon: Sparkles, iconColor: "text-[#005BBB]" },
    important: { bg: "bg-[#E3000F]/10", border: "border-[#E3000F]", icon: AlertTriangle, iconColor: "text-[#E3000F]" },
    remember: { bg: "bg-[#FFD100]/25", border: "border-[#FFD100]", icon: Lightbulb, iconColor: "text-yellow-700" },
    common_error: { bg: "bg-orange-100", border: "border-orange-500", icon: ShieldAlert, iconColor: "text-orange-600" },
  };
  const cfg = map[variant] || map.did_you_know;
  const Icon = cfg.icon;
  return (
    <div className={`${cfg.bg} border-4 ${cfg.border} rounded-2xl p-5 my-4 shadow-comic`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`w-6 h-6 ${cfg.iconColor}`} />
        <h4 className="font-display font-black text-lg tracking-wide uppercase">{title}</h4>
      </div>
      <div className="font-body text-base leading-relaxed text-neutral-900">{children}</div>
    </div>
  );
};

export const DoDontCompare = ({ doItems = [], dontItems = [] }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6">
    <div className="brutal p-5 bg-green-50 border-green-600" style={{ borderColor: "#16a34a" }}>
      <div className="flex items-center gap-2 mb-2 text-green-700">
        <Check className="w-6 h-6" />
        <h4 className="font-display font-black text-lg">✅ QUÉ HACER / DO</h4>
      </div>
      <ul className="space-y-2 font-body">
        {doItems.map((t, i) => (
          <li key={i} className="flex gap-2"><Check className="w-4 h-4 mt-1 text-green-600 shrink-0" /><span>{t}</span></li>
        ))}
      </ul>
    </div>
    <div className="brutal p-5 bg-red-50" style={{ borderColor: "#dc2626" }}>
      <div className="flex items-center gap-2 mb-2 text-red-700">
        <X className="w-6 h-6" />
        <h4 className="font-display font-black text-lg">❌ QUÉ NO HACER / DON&apos;T</h4>
      </div>
      <ul className="space-y-2 font-body">
        {dontItems.map((t, i) => (
          <li key={i} className="flex gap-2"><X className="w-4 h-4 mt-1 text-red-600 shrink-0" /><span>{t}</span></li>
        ))}
      </ul>
    </div>
  </div>
);
